import { Stack, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { SCAN_ANDROID_INTENT_LINK, SCAN_APP_STORE_LINK } from '@constants/scan';

import { useIsMobile } from '@hooks/useIsMobile';

import appStoreLogo from '@images/logos/apple.svg';
import googlePlayLogo from '@images/logos/google.svg';
import vitallScanLogo from '@images/logos/vitallscan-icon-red-nobg 1.svg';

const messages = defineMessages({
  vitallScanDescription: {
    id: 'scanEmptyState.vitallScanDescription',
    defaultMessage:
      'VITALL Scan allows you to easily create health data from face and body scans, which sync seamlessly with our main application.',
  },
  downloadVitallScanTitle: {
    id: 'scanEmptyState.downloadVitallScan.title',
    defaultMessage: 'Download VITALL Scan',
  },
  downloadVitallScanDescription: {
    id: 'scanEmptyState.downloadVitallScan.description',
    defaultMessage:
      'Click the buttons below to find and download the VITALL Scan app from the App Store or Google Play.',
  },
  installLaunchVitallScanTitle: {
    id: 'scanEmptyState.installLaunchVitallScan.title',
    defaultMessage: 'Install and Launch',
  },
  installLaunchVitallScanDescription: {
    id: 'scanEmptyState.installLaunchVitallScan.description',
    defaultMessage:
      'Once installed, open the app and follow the simple setup instructions.',
  },
  createSyncScanDataTitle: {
    id: 'scanEmptyState.createSyncScanData.title',
    defaultMessage: 'Create and Sync Scan Data',
  },
  createSyncScanDataDescription: {
    id: 'scanEmptyState.createSyncScanData.description',
    defaultMessage:
      'Start taking face and body scans. The app will seamlessly sync your scan results with the main application.',
  },
  viewScanResultsTitle: {
    id: 'scanEmptyState.title.viewScanResults',
    defaultMessage: 'View Scan Results',
  },
  viewScanResultsDescription: {
    id: 'scanEmptyState.viewScanResults.description',
    defaultMessage:
      'The results from each scan you take will be shown on this page.',
  },
});

function EmptyState() {
  const { formatMessage } = useIntl();
  const isMobile = useIsMobile();

  const logoWidth = isMobile ? 150 : 183;
  const btnWidth = isMobile ? 150 : 175;

  return (
    <Stack alignItems="center" spacing={3} py={3}>
      <img alt="VITALL Scan Logo" src={vitallScanLogo} width={logoWidth} />
      <Typography variant="body1">
        {formatMessage(messages.vitallScanDescription)}
      </Typography>
      <ol>
        <li>
          <Typography variant="subtitle1">
            {formatMessage(messages.downloadVitallScanTitle)}
          </Typography>
          <Typography variant="body2">
            {formatMessage(messages.downloadVitallScanDescription)}
          </Typography>
        </li>

        <li>
          <Typography variant="subtitle1">
            {formatMessage(messages.installLaunchVitallScanTitle)}
          </Typography>
          <Typography variant="body2">
            {formatMessage(messages.installLaunchVitallScanDescription)}
          </Typography>
        </li>

        <li>
          <Typography variant="subtitle1">
            {formatMessage(messages.createSyncScanDataTitle)}
          </Typography>
          <Typography variant="body2">
            {formatMessage(messages.createSyncScanDataDescription)}
          </Typography>
        </li>

        <li>
          <Typography variant="subtitle1">
            {formatMessage(messages.viewScanResultsTitle)}
          </Typography>
          <Typography variant="body2">
            {formatMessage(messages.viewScanResultsDescription)}
          </Typography>
        </li>
      </ol>
      <Stack direction="row" spacing={2} flexWrap="wrap">
        <a target="_blank" rel="noreferrer" href={SCAN_APP_STORE_LINK}>
          <img alt="App Store Logo" src={appStoreLogo} width={btnWidth} />
        </a>
        <a target="_blank" rel="noreferrer" href={SCAN_ANDROID_INTENT_LINK}>
          <img alt="Google Play Logo" src={googlePlayLogo} width={btnWidth} />
        </a>
      </Stack>
    </Stack>
  );
}

export default EmptyState;
